<template>
    <div style="margin-top: 15px">
      <iframe id="idFrame" name="nameFrame" :src="url" frameborder="0" width="100%" :height="this.height" allowfullscreen="true" v-if="hmac && encrypted"></iframe>
      <center v-else><b-spinner/></center>
    </div>
</template>

<script>
import {currencySymbol} from '@/helpers/labels.js'

export default {
  name: 'PageAxepta',

  data () {
    return {
      merchantId: 'BNP_TEST_MSG_ECOM_FR_EUR',
      urlBack: '',
      urlSuccess: 'https://axepta.dev.moneyroad.streammind.com/success',
      urlFailure: 'https://axepta.dev.moneyroad.streammind.com/failure',
      urlNotify: 'https://axepta.dev.moneyroad.streammind.com/notify',
      encrypted: undefined,
      hmac: undefined,
      error: false
    }
  },
  props: {
    refNr: '',
    transId: '',
    amount: '',
    currency: '',
    orderDesc: '',
    height: ''
  },
  computed: {
    amountInCents () {
      return this.amount * 100
    },
    params () {
      return `MerchantID=${this.merchantId}&TransID=${this.transId}&RefNr=${this.refNr}&Amount=${this.amountInCents}&Amount3D=${this.amountInCents}&Currency=${this.currency}&URLSuccess=${this.urlSuccess}&URLFailure=${this.urlFailure}&URLNotify=${this.urlNotify}&URLBack=${this.urlBack}&OrderDesc=${this.orderDesc}&MAC=${this.hmac}`
    },
    macPhrase () {
      return `*${this.transId}*${this.merchantId}*${this.amountInCents}*${this.currency}`
    },
    url () {
      return `https://paymentpage.axepta.bnpparibas/payssl.aspx?MerchantID=${this.merchantId}&Len=${this.params.length}&Data=${this.encrypted}&CustomField1=${(this.amountInCents / 100).toFixed(2)}${this.getCurrencySymbol(this.currency)}&CustomField3=https://www.streammind.com/wp-content/uploads/2021/03/logo-streammind.png`
    },
    urlOther () {
      return `https://paymentpage.axepta.bnpparibas/payssl.aspx?MerchantID=${this.merchantId}&Len=${this.params.length}&Data=${this.encrypted}&CustomField1=${(this.amountInCents / 100).toFixed(2)}${this.getCurrencySymbol(this.currency)}&CustomField2=IN08072021XAZS&CustomField3=https://www.streammind.com/wp-content/uploads/2021/03/logo-streammind.png&CustomField4=Peinture 110m2%0ACreation salle de bain&CustomField5=Michel Bard%0A43 rue des roses%0AParis 75008&CustomField8=Entrepreneur Selectionné&CustomField9=Henri Construction%0AParis 75007`
    }
  },
  methods: {
    fetchEncrypt () {
      let that = this
      that.error = false

      // Get Blowfish
      that.$engine.auth.encryption.hmac(that.macPhrase)
      .then(function (response) {
        if (response.error || response.Data === '') {
          that.error = true
        } else {
          that.hmac = response.Data
          // Get HMAC
          that.$engine.auth.encryption.blowfish(that.params)
          .then(function (response) {
            if (response.error) {
              that.error = true
            } else {
              that.encrypted = response.Data
            }
          })
        }
      })
    },
    getCurrencySymbol (currency) {
      return currencySymbol(currency)
    }
  },
  created () {
    if (window.location.href.includes('?')) {
      this.urlBack = ''
    } else {
      this.urlBack = window.location.href + '?loading=1'
    }
    this.fetchEncrypt()
  }
}
</script>

<style scoped>
.link:hover {
  text-decoration: underline;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// PageAxepta.vue?ec5d4f12